import axios from 'axios'
import { getToken } from '@/utils/auth'
import { encrypt, decrypt } from '@/utils/rsa'
import {
    getQueryString
} from '@/utils/location'

// 创建axios
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 20000 // request timeout
})
// 添加请求拦截器
service.interceptors.request.use(function(config) {
    if (config.data == '' ||config.data == undefined ||config.data == null) {
        config.data = new Object();
    }
    config.data.pt = "zk";
    config.data.key = getQueryString('key');
	config.data.appid = process.env.VUE_APP_BASE_APPID
	config.data.versionCode = 1

    if(!config.data.key){
        config.data.key = 'C7WglmY9'
    }

    // 7.7注释
    let token = getToken();
    if (token) {
        config.headers['wancms-users-token'] = token;
    }

    // JSON.stringify(config.data);
    console.log( JSON.stringify(config.data)+'-----------------加密前的参数')
    config.data = JSON.stringify(config.data);
    encrypt(config.data);
    // console.log(encrypt(config.data)+'-----------------加密后的参数')
    config.data = encrypt(config.data);
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function(response) {
    // 对响应数据做点什么
    response.data = decrypt(response.data);
    response.data = JSON.parse(response.data);
    // console.log('res', response);

    return response;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default service;